/////////////////////////////////////////
// IMPORT
/////////////////////////////////////////
import EventEmitter from 'events'
import { defined } from 'junctions-fp'
import KeyUtils from '../tools/KeyUtils'
/**
 * Insctance of KeyBoardManager
 * @class KeyBoardManager
 */
class KeyBoardManager extends EventEmitter {
  /**
   * Creates an instance of KeyBoardManager
   * @memberof KeyBoardManager
   */
  constructor(canvas) {
    super()
    this.canvas = canvas
    this.__createListeners()
  }
  /////////////////////////////////////////
  // METHODS
  /////////////////////////////////////////
  /**
   * Définit les écouteur pour la gestion des raccourcis clavier
   *
   * @memberof KeyBoardManager
   */
  __createListeners() {
    window.addEventListener('keyup', this.__keyUp.bind(this))
    window.addEventListener('keydown', this.__keyDown.bind(this))
  }
  /**
   * déclenché lorsqu'une touche est enfoncé
   *
   * @param {any} evt
   * @memberof KeyBoardManager
   */
  __keyUp(evt) {
    //scale off
    const ku = new KeyUtils(evt)
    if (this.__isTextBoxEditing() || evt.target !== document.body) {
      return
    }

    switch (ku.getKey()) {
      case 'shift':
        if (this.__hasActiveObject()) {
          this.emit(KeyBoardManager.EVENT_LOCK_SCALE_OFF)
        }
        break
      case 't':
        this.emit(KeyBoardManager.EVENT_CREATE_TEXTBOX)
        break
      case 'f':
        this.emit(KeyBoardManager.EVENT_SHOW_FILTER)
        break
      case 'i':
        this.emit(KeyBoardManager.EVENT_SHOW_IMAGE)
        break
      case 'a':
        this.emit(KeyBoardManager.EVENT_SHOW_ADJUSTEMENT)
        break
      case 'o':
        this.emit(KeyBoardManager.EVENT_SHOW_SHAPE)
        break
      case 'l':
        this.emit(KeyBoardManager.EVENT_SHOW_TEMPLATE)
        break
      case 'c':
        this.emit(KeyBoardManager.EVENT_SHOW_LAYER)
        break
      case 'm':
        this.emit(KeyBoardManager.EVENT_ACTIVE_MAGNET)
        break
      case 'g':
        this.emit(KeyBoardManager.EVENT_SHOW_GRID)
        break
    }

    // delete
    if (ku.isDeleteBack) {
      this.emit(KeyBoardManager.EVENT_DELETE)
    }
  }
  /**
   * déclenché lorsqu'une touche est relaché
   *
   * @param {any} evt
   * @memberof KeyBoardManager
   */
  __keyDown(evt) {
    const ku = new KeyUtils(evt)
    switch (ku.getKey()) {
      case 'arrowleft':
      case 'arrowup':
      case 'arrowright':
      case 'arrowdown':
        this.emit(KeyBoardManager.EVENT_ARROW, ku.getKey(), ku.isShift)
        return
    }

    if (!evt.repeat) {
      if (this.__isTextBoxEditing() || evt.target !== document.body) {
        return
      }
      if (ku.isKey('shift') && this.__hasActiveObject()) {
        this.emit(KeyBoardManager.EVENT_LOCK_SCALE_ON)
      }
      // copy
      if (ku.isKey('c') && ku.isControl) {
        this.emit(KeyBoardManager.EVENT_COPY)
        return
      }
      // paste
      if (ku.isKey('v') && ku.isControl) {
        this.emit(KeyBoardManager.EVENT_PASTE)
        return
      }

      // undo
      if (ku.isKey('z') && (ku.isControl || ku.isMeta || ku.isShift)) {
        this.emit(KeyBoardManager.EVENT_UNDO)
        return
      }
    }
  }

  /**
   * Renvoit si l'utilisateur se trouve dans un TextBox en mode édition
   * @private
   * @returns {Boolean} true si l'utilisateur est dans un TextBox en mode édition
   * @memberof KeyBoardManager
   */
  __isTextBoxEditing() {
    return this.canvas.getActiveObject() instanceof fabric.Textbox && this.canvas.getActiveObject().isEditing
  }
  /**
   *
   * @private
   * @returns {boolean}
   * @memberof KeyBoardManager
   */
  __hasActiveObject() {
    return defined(this.canvas.getActiveObject())
  }
  /////////////////////////////////////////
  // GETTERS / SETTERS
  /////////////////////////////////////////
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_SHAPE() {
    return 'EVENT_SHOW_SHAPE'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_PASTE() {
    return 'EVENT_PASTE'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_UNDO() {
    return 'EVENT_UNDO'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_COPY() {
    return 'EVENT_COPY'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_DELETE() {
    return 'EVENT_DELETE'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_GRID() {
    return 'EVENT_SHOW_GRID'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_LOCK_SCALE_ON() {
    return 'EVENT_LOCK_SCALE_ON'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_LOCK_SCALE_OFF() {
    return 'EVENT_LOCK_SCALE_OFF'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_CREATE_TEXTBOX() {
    return 'EVENT_CREATE_TEXTBOX'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_FILTER() {
    return 'EVENT_SHOW_FILTER'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_IMAGE() {
    return 'EVENT_SHOW_IMAGE'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_ADJUSTEMENT() {
    return 'EVENT_SHOW_ADJUSTEMENT'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_TEMPLATE() {
    return 'EVENT_SHOW_TEMPLATE'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_SHOW_LAYER() {
    return 'EVENT_SHOW_LAYER'
  }
  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_ACTIVE_MAGNET() {
    return 'EVENT_ACTIVE_MAGNET'
  }

  /**
   *
   *
   * @readonly
   * @static
   * @memberof KeyBoardManager
   */
  static get EVENT_ARROW() {
    return 'EVENT_ARROW'
  }
}
export default KeyBoardManager



// WEBPACK FOOTER //
// ./src/model/pixel/elements/KeyBoardManager.js